module.exports = __webpack_public_path__ + "static/media/google.cfb1cd6b.svg";